import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { ReactComponent as ChevronRight } from 'assets/images/svg/chevron-right.svg';
import SGForCourses from 'assets/images/sg-for-courses-banner.jpg';

import Text from 'components/shared/ui/Text';

import siteStyle, { M } from 'utils/siteStyle';
import { FREE_MARKETPLACE } from 'utils/routes';

const ForCourseBanner = ({ className }) => {
  const history = useHistory();

  const getAppName = () => {
    let name;
    switch (process.env.REACT_APP_NAME) {
      case 'supremeGolf':
      case 'foldsOfHonor':
      case 'theWeatherChannel':
        name = 'SG';
        break;
      case 'barstool':
        name = 'Barstool';
        break;
      case 'golfDigest':
        name = 'Golf Digest';
        break;
      default:
        name = '';
    }
    return name;
  };

  const handleTileClick = () => {
    if (M.SG || M.FOH || M.TWC) {
      const a = document.createElement('a');
      a.href = 'https://courses.supremegolf.com/?utm_source=supremegolf.com&utm_medium=referral&utm_campaign=homepage%22';
      a.target = '_blank';
      a.rel = 'noopener norefferer';
      a.click();
    } else {
      history.push(FREE_MARKETPLACE);
    }
  };

  return (
    <section className={className}>
      <div className="w-full max-w-300">
        <Text variant="h3">
          {`${getAppName()} For Courses`}
        </Text>
        <p className="pt-1 font-primary-two text-4 leading-5 -tracking-0.2 text-dark md:pt-2">For course owners and operators.</p>
        <div className="mt-4 border border-light-grey-four rounded-2 overflow-hidden md:mt-6 md:flex md:items-center cursor-pointer" onClick={handleTileClick} aria-hidden>
          <div className="flex-1 h-50 md:h-60 md:max-w-104">
            <img
              src={SGForCourses}
              className="w-full h-full object-cover object-center"
              alt="sg for courses banner"
            />
          </div>
          <div className="px-4 py-6 md:px-6 lg:px-10">
            <h2
              className={siteStyle({
                common: 'text-5 leading-6 -tracking-0.2 text-dark',
                // bt: 'font-korolav font-bold uppercase',
                default: 'font-primary font-black',
              })}
            >
              Are you a course owner?
            </h2>
            <p className="mt-2 font-primary-two text-4 leading-5 text-grey-3 -tracking-0.2">
              List your course with us! Learn more about
              <br className="hidden md:block lg:hidden" />
              {' '}
              listing your golf course
              <br className="hidden lg:block xl:hidden" />
              {' '}
              with
              {' '}
              <span className="capitalize">{`${process.env.REACT_APP_FRIENDLY_NAME.toLowerCase()}.`}</span>
            </p>
            <button
              className={siteStyle({
                common: 'font-bold flex items-center gap-2 text-4 leading-4 -tracking-0.2 text-dark mt-6 md:mt-4 focus:outline-none',
                // bt: 'font-korolav uppercase',
                default: 'font-primary',
              })}
            >
              <span className="inline-block">Learn more</span>
              <ChevronRight className="w-3 h-3 text-dark fill-current" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

ForCourseBanner.defaultProps = {
  className: '',
};

ForCourseBanner.propTypes = {
  className: PropTypes.string,
};

export default ForCourseBanner;
